import styled from 'styled-components';
import { ArdoqId } from '@ardoq/api-types';
import { fontSizeDefinitions_DEPRECATED } from '../../atomicComponents/fonts/fontSizeDefinitionsWithDefaultFont';
import { isPresentationMode } from 'env';
import { verticalSpacing } from 'tabview/pagesView/constants';
import { GetContentOptionsType } from 'appModelStateEdit/legacyTypes';
import { dispatchAction } from '@ardoq/rxbeach';
import { showRightPane } from 'appContainer/actions';
import { navigate } from '../../router/declarative/streamRouterAdapter/actions';

const EditButton = styled.span`
  ${fontSizeDefinitions_DEPRECATED.MEDIUM}
  cursor: pointer;
  margin: ${verticalSpacing.SMALL} 9px 0 auto;
  height: 20px;
  text-transform: uppercase;
  @media print {
    display: none;
  }
`;

const EditDescriptionButton = ({
  modelId,
  isComponent,
  descriptionIsEmpty,
  canEditDescription,
}: {
  modelId: ArdoqId;
  isComponent: boolean;
  descriptionIsEmpty: boolean;
  canEditDescription: boolean;
}) => {
  const modelString = isComponent ? 'component' : 'workspace';
  const actionString = descriptionIsEmpty ? 'Add' : 'Edit';

  return canEditDescription && !isPresentationMode() ? (
    <EditButton
      data-click-id={`edit-${modelString}-description-button`}
      data-tooltip-text={`${actionString} ${modelString} description`}
      onClick={() =>
        dispatchAction(
          isComponent
            ? showRightPane({
                type: GetContentOptionsType.COMPONENT_PROPERTIES,
                componentIds: [modelId],
              })
            : navigate({
                route: '/workspace-manager/:workspaceId/settings',
                params: { workspaceId: modelId },
              })
        )
      }
    >
      {actionString}
    </EditButton>
  ) : null;
};

export { EditDescriptionButton };
